function lineup() {

    if ( !! $('.lnav').length ) {

        $('ul.lnav>li>a').on("click", function(){

            var el = $(this);
            var lnavgroup = el.attr('data-lnav');
            var width = $(document).width();

            if ( el.hasClass('active')) {
                return;
            } else {

                $('ul.lnav a.active').removeClass('active');
                el.addClass('active');

            }

            if (width <= 780) {

                if ( lnavgroup == 'ALL') {
                    $('div.daygroup').fadeTo(300,1);
                } else {
                    $('div.daygroup').hide();
                    $('div.daygroup.'+lnavgroup).fadeTo(300,1);
                }

            } else {

                $('div.daygroup').fadeIn(1);

                if ( lnavgroup == 'ALL') {
                    $('div.daygroup').fadeTo(300,1);
                } else {
                    $(`div.daygroup:not(.${lnavgroup})`).fadeTo(100,.2);
                    $(`div.daygroup.${lnavgroup}`).fadeTo(300,1);
                }

                $('div.daygroup').css( { 'display' : 'inline-block'} );

            }

        });

    }

}
